import { create } from "zustand";

type NavState = {
  /** Whether the global Sync-to-Calendar dialog is open. */
  calendarSyncOpen: boolean;
};

type NavActions = {
  setCalendarSyncOpen: (open: boolean) => void;
};

export const useNavStore = create<NavState & NavActions>((set) => ({
  calendarSyncOpen: false,
  setCalendarSyncOpen: (open) => set({ calendarSyncOpen: open }),
}));
